import React from "react";

// components
import SearchBar from "../index";
import DropDownAndInput from "../components/DropDownAndInput";
import SearchButton from "../components/SearchButton";

// This is the default variation
// all the default styles of the SearchBar reflect the HeaderSearchBar
export const HeaderSearchBar = props => {
    const { id = "header-search" } = props;

    return (
        <SearchBar {...props} id={id}>
            <DropDownAndInput />
            <SearchButton />
        </SearchBar>
    );
};

export default HeaderSearchBar;

import PropTypes from "prop-types";

// prop-types
HeaderSearchBar.propTypes = {
    id: PropTypes.string
};
